import PropTypes from "prop-types";
import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import { pl } from "date-fns/locale/pl";

import "react-datepicker/dist/react-datepicker.css";
import { validateAttributes, errorMessage } from "../utils/validations";
import { validations } from "./validations";

const NewClientModal = (props) => {
  const { clients, setClients, setNewClientModal } = props;
  registerLocale("pl", pl);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState("");
  const [userLimit, setUserLimit] = useState(5);
  const [validTo, setValidTo] = useState(new Date());

  const postClient = async () => {
    const response = await fetch("/clients", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
      },
      body: JSON.stringify({
        client: {
          name: name,
          email: email,
          user_limit: userLimit,
          client_valid_to: validTo,
        },
      }),
    });
    if (response.ok) {
      const data = await response.json();
      setClients([...clients, ...[data.client]]);
      setNewClientModal(false);
    } else {
      console.log("error");
    }
  };

  const onClose = () => {
    setNewClientModal(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validation = validateAttributes(
      {
        name,
        email,
        userLimit,
        validTo,
      },
      validations,
    );

    setErrors(validation);

    if (validation) return;
    postClient();
  };

  const className = (attribute) => {
    let className = "flex-1 bg-gray-100 px-3 py-2";
    if (errors && errors[attribute]) {
      className += " border border-red-500 focus:ring-red-500";
    }
    return className;
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white shadow-lg p-6 w-full max-w-lg relative space-y-6">
        <h1 className="font-bold">Dodaj Clienta</h1>
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-black"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <path d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <form onSubmit={handleSubmit} className="space-y-3">
          <div className="flex gap-4">
            <span className="w-48 text-gray-500 flex items-center gap-1">
              Nazwa
            </span>
            <input
              className={className("name")}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="flex gap-4">{errorMessage(errors, "name")}</div>

          <div className="flex gap-4">
            <span className="w-48 text-gray-500 flex items-center gap-1">
              Email
            </span>
            <input
              className={className("email")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="flex gap-4">{errorMessage(errors, "email")}</div>

          <div className="flex gap-4">
            <span className="w-48 text-gray-500 flex items-center gap-1">
              Limit Użytkowników
            </span>
            <input
              className={className("userLimit")}
              value={userLimit}
              onChange={(e) => setUserLimit(e.target.value)}
              type="number"
              min={1}
            />
          </div>

          <div className="flex gap-4">{errorMessage(errors, "userLimit")}</div>

          <div className="flex gap-4">
            <span className="w-48 text-gray-500 flex items-center gap-1">
              Aktywne do
            </span>
            <DatePicker
              className={className("validTo")}
              selected={validTo}
              onChange={(value) => setValidTo(value)}
              locale="pl"
              dateFormat={"dd.MM.yyyy"}
            />
          </div>

          <div className="flex gap-4">{errorMessage(errors, "validTo")}</div>

          <button
            type="submit"
            className="flex items-center gap-2 bg-black text-white px-4 py-2"
          >
            Zapisz
          </button>
        </form>
      </div>
    </div>
  );
};

export default NewClientModal;

NewClientModal.propTypes = {
  clients: PropTypes.array,
  setClients: PropTypes.func,
  setNewClientModal: PropTypes.func,
};
